// extracted by css-extract-rspack-plugin
export default {"container":"warning-module__container___eIORn"};